import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table,Form, Button } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import ResalesRequestService from '../../../services/resales-request';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import {maskDocument, documentType, maskZip} from 'helpers/document';
import { useParams } from 'react-router-dom';
import { setContext } from 'redux-saga/effects';

const Attendance = () => {
  const defaultFilters = { search: '', per_page: 10, page: 1, elite: '' };
  const [filters, setFilters] = useState(defaultFilters);
  //const [reports, setReports] = useState({data:[]});
  const [reports, setReports] = useState({data:[]});
  const [company, setCompany] = useState([]);
  const [info, setInfo] = useState({segment:[],client_type:[]});
  const [erroRequired, setErroRequired] = useState({campos:[],erro:false})

  const [formEdit, setFormEdit] = useState(false);
  const [formChanges, setFormChanges] = useState(null);
  const [wasModified, setWasModified] = useState(false);
  const [messageErro, setMessageErro] = useState(false);
  const Data = [];

  useEffect(() => {
    if(localStorage.getItem('companyId')!=null){
    //   let info = ResalesRequestService.getInfoResale();
    //   info.then(data => {
    //     setInfo(data.data);
    //   })
      let users = ResalesRequestService.getResaleAttendance(localStorage.getItem('companyId'),{ params: { ...filters } });
      users
      .then(data => {
        setReports(data.data);
      });
    } else {
      setMessageErro(true);
    }
  }, [filters]);


  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page });

  const columns = [
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'type',
      text: 'Tipo',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'email',
      text: 'E-mail',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'phone',
      text: 'Telefone',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
  ];

  const renderData = () => {
    Object.values(reports.data).map((user, k) => {
      Data.push({
        id: user.id,
        name: user.name+' '+user.lastname,
        email: user.email,
        phone: user.phone,
        type: user.type_name
      });
    });
  }
  renderData();
  const listAttendance = ()=>{
    return (
        <>
          <Container fluid>
            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Row>
                      <Col xs={6} className="align-self-center">
                        <h4 className={styles.headerTitle}>
                          Atendimento
                        </h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <hr className={styles.line} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={3}>
                        <Form.Group>
                          <Form.Label>Registros por página:</Form.Label>
                          <Form.Control
                            as="select"
                            value={filters.per_page}
                            onChange={e =>
                              handleFilterChange({ per_page: e.target.value })
                            }
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Form.Group>
                          <Form.Label>Pesquisa:</Form.Label>
                          <Form.Control
                            as="input"
                            //value={filters.per_page}
                            onChange={e => handleFilterChange({ search: e.target.value })}
                          >
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <BootstrapTable
                      id="table"
                      className="font-10"
                      keyField="id"
                      data={Data}
                      columns={columns}
                      noDataIndication={()=>{
                          return (<div className="text-xl-center font-12">Sem dados disponíveis na tabela</div>);
                      }}
                      //expandRow={expandRow}
                    />
                    <Row>
                      <Col>
                        <Trans i18nKey="label:interpolateShowingRecords">
                          Showing {{ from: reports.from || '0' }} to{' '}
                          {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                          records
                        </Trans>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Pagination
                          activePage={reports.current_page}
                          itemsCountPerPage={reports.per_page}
                          totalItemsCount={reports.total}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          prevPageText="‹"
                          nextPageText="›"
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      );
  };

  const showMessageErro = ()=>{
    return (
      <>
        <Container fluid>
          <Row>
            <Col className="col-12 d-flex justify-content-center my-5">
              <Card className="card border border-dark text-center col-8">
                <Card.Body>
                  <Row>
                    <Col className="col-12 align-self-center p-5">
                      <h3 className="text-black mb-4 px-4">Você precisa selecionar uma revenda para visualizar os dados.</h3>
                      <a className="btn btn-primary btn-lg" href="./" role="button" onClick={()=>{
                        localStorage.setItem('returnPage',window.location.href);
                      }}>Selecionar Revenda</a>
                    </Col>
                  </Row>
                </Card.Body> 
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  };
return (<>{
    messageErro?showMessageErro():listAttendance()
    }</>);
};

export default MasterPage(Attendance);